<template>
  <div class="logistic-index">
    <div class="logistic-nav-bar">
      <van-nav-bar title="查询" right-text="免费申请" :left-arrow="isInAPP" @click-left="onClickLeft" @click-right="onClickRight" />
    </div>
    <div class="search-ctn" v-if="!isInAPP">
      <div class="search-form">
        <van-field v-model.trim="organSign" label="机构ID" label-width="110" input-align="right" placeholder="请输入" />
        <van-field v-model.trim="phone" label="收件人手机号" label-width="110" input-align="right" placeholder="请输入" />
      </div>
      <div class="btn" @click="doSearch">查询</div>
    </div>
    <div class="list" :class="isInAPP ? 'top' : ''">
      <div class="list-header">共查询到{{ total }}条结果</div>
      <div class="ul">
        <div class="li" v-for="(item, id) in list" :key="id">
          <div class="row-1">{{ item.company }}</div>
          <div class="row-2">
            <span class="number">{{ item.number }}</span>
            <span class="btn-copy" onclick="" :data-clipboard-text="item.number">复制</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { goUrl, appFinish, goNewWebview } from '@/utils/appMe.js'
import { toast, debounce } from '@/utils/index'
import { getSign } from '@/utils/auth.js'
import { getFastMailInfo } from '@/api/logistics.js'
import ClipboardJS from 'clipboard'
export default {
  components: {},
  data() {
    return {
      organSign: '',
      phone: '',
      total: 0,
      list: [],
      source: '',
      clipboard: null
    }
  },
  computed: {
    isInAPP() {
      return this.source === 'app'
    }
  },
  created() {
    document.title = '快递查询'
    const { source } = this.$route.query
    this.source = source || ''
    if (this.isInAPP) {
      this.getFastMailInfo({ organSign: getSign() })
    }
  },
  mounted() {
    this.clipboard = new ClipboardJS('.btn-copy')
    this.clipboard.on('success', function(e) {
      toast('复制成功')
      e.clearSelection()
    })
    this.clipboard.on('error', function(e) {
      console.log(e)
    })
    this.debounceSearch = debounce(
      () => {
        this.getFastMailInfo({
          organSign: this.organSign,
          phone: this.phone
        })
      },
      500,
      true
    )
  },
  destroyed() {
    this.clipboard.destroy()
  },
  methods: {
    onClickLeft() {
      if (this.isInAPP) {
        this.$router.go(-1)
      }
    },
    onClickRight() {
      if (this.isInAPP) {
        goNewWebview('https://h5.ebdan.net/ls/UnHWBLye', '1', '小智会员专属物料领取')
      } else {
        window.location.href = 'https://h5.ebdan.net/ls/UnHWBLye'
      }
    },
    validate() {
      if (!this.organSign) {
        toast('请输入机构ID')
        return false
      }
      if (!this.phone) {
        toast('请输入手机号')
        return false
      }
      if (!/^1\d{10}$/.test(this.phone)) {
        toast('手机号格式有误')
        return false
      }
      return true
    },
    async doSearch() {
      if (!this.validate()) return
      this.debounceSearch()
    },
    async getFastMailInfo(params = {}) {
      try {
        // sourceType 0表示app里面打开 1表示 h5打开
        const sourceType = this.isInAPP ? 0 : 1
        params.sourceType = sourceType
        const res = await getFastMailInfo(params)
        this.list = res
        this.total = this.list.length
        if (this.list.length < 1) {
          toast('暂无物流信息单号')
          return
        }
      } catch (error) {
        console.log('getFastMailInfo', error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.logistic-index {
  background: #f5f7f8;
  width: 375px;
  min-height: 100vh;
  overflow: hidden;
  .logistic-nav-bar {
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 999;
    .van-nav-bar__left {
      .van-icon {
        color: #000;
        font-size: 18px;
      }
    }
    .van-nav-bar__right {
      .van-nav-bar__text {
        font-size: 16px;
        color: #1678ff;
      }
    }
    .van-nav-bar__title {
      font-family: PingFangSC-Regular;
      font-size: 18px;
      color: #30303c;
    }
    .van-hairline--bottom::after {
      border: none;
    }
  }
  .search-ctn {
    .search-form {
      width: 345px;
      height: 108px;
      border: 0 solid #eef2f4;
      box-shadow: 0 0 10px 0 rgba(48, 48, 60, 0.02);
      border-radius: 5px;
      background: #ffffff;
      margin: 55px 15px 20px;
    }
    .btn {
      width: 345px;
      height: 45px;
      line-height: 45px;
      background: #408afd;
      border-radius: 23px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      margin: 0 auto;
    }
    .van-cell {
      line-height: 34px;
    }
    .van-cell.van-field {
      font-size: 16px;
    }
  }
  .list {
    &.top {
      margin-top: 45px;
    }
    .list-header {
      font-family: PingFangSC-Regular;
      font-size: 15px;
      color: #a1a5b0;
      padding: 9px 0 10px 25px;
    }
    .li {
      width: 345px;
      height: 80px;
      box-sizing: border-box;
      background: #ffffff;
      border: 0 solid #eef2f4;
      box-shadow: 0 0 10px 0 rgba(48, 48, 60, 0.02);
      border-radius: 5px;
      padding: 16px 0 16px 15px;
      margin: 0 15px 10px 15px;
    }
    .row-1 {
      font-size: 16px;
      color: #30303c;
      margin-bottom: 5px;
    }
    .row-2 {
      font-size: 15px;
      display: flex;
      align-items: center;
    }
    .number {
      font-size: 15px;
      color: #a1a5b0;
      margin-right: 21px;
    }
    .btn-copy {
      display: inline-block;
      width: 34px;
      height: 16px;
      line-height: 16px;
      text-align: center;
      background: #f2f3f3;
      border-radius: 8px;
      font-size: 11px;
      color: #292933;
      cursor: pointer;
    }
  }
}
</style>
